import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import {IconComponent} from "../../reusable/simpleComponents";
import {authReset, stopHeartBeaten} from "../../../store/API/actions";
import { chooseService } from '../../../utils';
import service from '../../../services';
import { ApplicationState } from '../../../store';
import { APIState } from '../../../store/API/types';


const LogoutUIComponent = () => {
    const dispatch = useDispatch();
    const { token } = useSelector<ApplicationState, APIState>(state => state.API);

    const handler = () => {
        if (window.confirm('Are you sure you want to log out?')) {
            window.localStorage.removeItem('token');
            window.localStorage.removeItem('token2');
            dispatch(authReset());
            dispatch(stopHeartBeaten());
            chooseService(
                () => {},
                () => {
                    service.disconnect(token);
                }
            );
        }
    };

    return (
        <IconComponent classValue={'logout-icon icon'}
                       handler={handler}
                       title="Log Out"
        />
    )
};

export default LogoutUIComponent